import * as React from 'react';
import { Bank } from '@liveauctioneers/hammer-ui-core/icons';
import { BodySecondary, H3 } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import BankAccountOnFileWithPlaidVerifyContainer from '@/components/Plaid/BankAccountOnFileWithPlaidVerifyContainer';
import LaPlaidLink from '@/components/Plaid/LaPlaidLink';
import styled from 'styled-components';

type Props = {
    bankAccountToDisplay: React.ComponentProps<typeof BankAccountOnFileWithPlaidVerifyContainer>['bankAccount'];
    onBankAccountDelete: (bankAccountId: number, plaidAccountId?: string) => void;
};

// Component on account settings that will either show an account, or the add account text
const BankAccountOnFileWrapper = ({ bankAccountToDisplay, onBankAccountDelete }: Props) => {
    return (
        <>
            {Boolean(bankAccountToDisplay) && bankAccountToDisplay.enabled ? (
                <BankAccountOnFileWithPlaidVerifyContainer
                    bankAccount={bankAccountToDisplay}
                    deleteAccount={() =>
                        onBankAccountDelete(bankAccountToDisplay.bankAccountId, bankAccountToDisplay.plaidAccountId)
                    }
                    deleteAccountLinkText="Remove"
                />
            ) : (
                <AddCard>
                    <AchDiv>
                        <Bank
                            color="secondary"
                            size="lg"
                            style="duotone"
                        />
                        <AchText>
                            <StyledBankAccountTitle>
                                <FormattedMessage id="accountSettings.bankAccountTitle" />
                            </StyledBankAccountTitle>
                            <BodySecondary>
                                <FormattedMessage id="accountSettings.bankDetails" />
                            </BodySecondary>
                        </AchText>
                    </AchDiv>
                    <LaPlaidLink />
                </AddCard>
            )}
        </>
    );
};

export default BankAccountOnFileWrapper;

const AddCard = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.grey400};
    padding: 32px;
    margin: 0;
`;

const AchDiv = styled.div`
    display: flex;
    align-items: center;
`;

const AchText = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 20px;
`;

const StyledBankAccountTitle = styled(H3)`
    margin-bottom: 4px;
`;
